module.exports = __webpack_public_path__ + "img/C05TechOnagerChampion_ua.870eb328.webp";